import { CHAT_FILTERS_OPTIONS } from "../../constants"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { I18n } from "react-redux-i18n"
import { setFilterText, toggleMessageFilter, resetMessageFilters } from "redux/actions/conversations/messageFiltersAct"

function useFilterMenu () {
  const dispatch = useDispatch()
  const {
    conversations,
    tabs: { activeUser },
  } = useSelector(store => store)
  const [isOpenOptions, setIsOpenOptions] = useState(false)
  const [searchText, setSearchText] = useState('')

  const conversation = conversations[activeUser]
  const { chat } = conversation
  const { messageFilters: { filterText, filterValue } } = chat

  const handleToggleOptions = () => setIsOpenOptions(!isOpenOptions)

  useEffect(() => {
    setSearchText(filterText)
  }, [])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(setFilterText(activeUser, searchText))
    }, 300)

    return () => clearTimeout(timeoutId)
  }, [searchText, dispatch, activeUser])

  const handleFiltersMessages = (type, value) => {
    if (type === "text") {
      setSearchText(value)
    } else {
      dispatch(toggleMessageFilter(activeUser, type))
    }
  }

  const handleResetFilter = () => {
    setSearchText('')
    dispatch(resetMessageFilters(activeUser))
  }

  const getFilterOptions = () => {
    try {
      const filterOptions = []
  
      CHAT_FILTERS_OPTIONS.forEach(filter => {
        filterOptions.push({
          type: filter.name,
          value: filterValue?.includes(filter.name) || false,
          iconName: filterValue?.includes(filter.name) || false ? filter.activeIcon : filter.icon,
          name: I18n.t(filter.text)
        })
      })
  
      return filterOptions
    } catch (error) {
      console.error('error: ', error)
    }
  }
  return {
    isOpenOptions,
    searchText,
    handleToggleOptions,
    handleFiltersMessages,
    handleResetFilter,
    getFilterOptions,
  }
}

export default useFilterMenu